import { useEffect, useState } from "react";
import HomeServicesItem from "../Components/HomeServicesItem";
import styles from "../Components/ProductList.module.css";
import Api from "../api/ecomApi";
const HomeServices = () => {
  const [services, setServices] = useState([]);
  useEffect(()=>{
    Api.get(`home-services/`).then((response)=>{
      setServices(response.data);      
    }).catch((error)=>{
      console.log(error);

    })
  }, []);  
    return (
        <>
        <div className={`col-sm-12 ${styles.mainContainer}`}>
        <div className="container-fluid">          
          <div className="row">
            { services.map((item)=>(<HomeServicesItem key={item.id} item={item} />
            ))}       
          </div>
        </div>
      </div>
      </>

    );
}
export default HomeServices;